import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../useData";

// Loads Google Analytics 4 dynamically from the ga_id stored in settings
// (editable via /admin → Info tab). If ga_id is empty, does nothing.
// Also fires a page_view on every client-side route change.
const GoogleAnalytics = () => {
  const settings = useSettings();
  const gaId = settings?.ga_id?.trim();
  const location = useLocation();

  // Inject GA script once when gaId becomes available.
  useEffect(() => {
    if (!gaId || !/^G-[A-Z0-9]+$/i.test(gaId)) return;
    if (window.__ga_loaded === gaId) return;

    // Remove any previous GA scripts (e.g. if the id was swapped)
    document
      .querySelectorAll("script[data-ga-loader]")
      .forEach((s) => s.remove());

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    s1.setAttribute("data-ga-loader", "1");
    document.head.appendChild(s1);

    const s2 = document.createElement("script");
    s2.setAttribute("data-ga-loader", "1");
    s2.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', '${gaId}', { send_page_view: false });
    `;
    document.head.appendChild(s2);

    window.__ga_loaded = gaId;
  }, [gaId]);

  // Fire page_view on every route change.
  useEffect(() => {
    if (!gaId || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [gaId, location.pathname, location.search]);

  return null;
};

export default GoogleAnalytics;
